import React from 'react';
import {
  Box,
  Typography,
  TextField,
  Button,
  Divider,
  Grid,
  FormControl,
  RadioGroup,
  FormControlLabel,
  Radio,
  FormHelperText,
  FormGroup,
  Checkbox,
  IconButton
} from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import DeleteIcon from '@mui/icons-material/Delete';
import { useFormContext } from './FormContext';

const Page4Objectives: React.FC = () => {
  const { 
    formData, 
    errors, 
    handleChange, 
    handleCheckboxChange,
    handleFaqChange,
    addFaq,
    removeFaq
  } = useFormContext();

  return (
    <>
      <Typography variant="h6" gutterBottom sx={{ mt: 2, mb: 2, color: "primary.main" }}>
        Seção 4: Objetivos e Ações (O que o Assistente Deve Fazer)
      </Typography>
      <Typography variant="body2" gutterBottom sx={{ mb: 2, fontStyle: 'italic' }}>
        Aqui definimos as tarefas principais do assistente.
      </Typography>
      <Divider sx={{ mb: 3 }} />

      <Grid container spacing={3}>
        <Grid item xs={12}>
          <Typography variant="subtitle1" gutterBottom>
            Qual é o principal objetivo do assistente virtual? (Escolha o mais importante)
          </Typography>
          <FormControl component="fieldset" error={!!errors.mainObjective}>
            <RadioGroup
              name="mainObjective"
              value={formData.mainObjective}
              onChange={handleChange}
            >
              <FormControlLabel value="answer_faqs" control={<Radio />} label="Responder perguntas frequentes para liberar meu tempo." />
              <FormControlLabel value="qualify_clients" control={<Radio />} label="Qualificar clientes (entender o que eles querem antes de passar para mim)." />
              <FormControlLabel value="schedule_appointments" control={<Radio />} label="Agendar horários/consultas." />
              <FormControlLabel value="sell_products" control={<Radio />} label="Apresentar produtos/serviços e fechar vendas simples." />
            </RadioGroup>
            {errors.mainObjective && (
              <FormHelperText error>{errors.mainObjective}</FormHelperText>
            )}
          </FormControl>
        </Grid>

        <Grid item xs={12}>
          <Typography variant="subtitle1" gutterBottom>
            Perguntas Frequentes (FAQs): Liste as 5 perguntas que você mais recebe dos clientes e qual deve ser a resposta exata do assistente.
          </Typography>
          
          {formData.faqs.map((faq, index) => (
            <Box key={index} sx={{ mb: 3, p: 2, border: '1px solid #e0e0e0', borderRadius: 1 }}>
              <Grid container spacing={2} alignItems="center">
                <Grid item xs={11}>
                  <Typography variant="subtitle2">
                    Pergunta {index + 1}:
                  </Typography>
                </Grid>
                <Grid item xs={1}>
                  {index > 0 && (
                    <IconButton 
                      aria-label="delete"
                      onClick={() => removeFaq(index)}
                      color="error"
                    >
                      <DeleteIcon />
                    </IconButton>
                  )}
                </Grid>
                <Grid item xs={12}>
                  <TextField
                    fullWidth
                    label="Pergunta"
                    value={faq.question}
                    onChange={(e) => handleFaqChange(index, 'question', e.target.value)}
                    sx={{ mb: 2 }}
                  />
                </Grid>
                <Grid item xs={12}>
                  <TextField
                    fullWidth
                    label="Resposta Ideal"
                    multiline
                    rows={3}
                    value={faq.answer}
                    onChange={(e) => handleFaqChange(index, 'answer', e.target.value)}
                  />
                </Grid>
              </Grid>
            </Box>
          ))}
          
          {formData.faqs.length < 5 && (
            <Box>
              <Button 
                startIcon={<AddIcon />} 
                onClick={addFaq}
                variant="outlined"
                sx={{ mt: 1 }}
              >
                Adicionar Pergunta
              </Button>
              {errors.faqs && (
                <Typography color="error" variant="body2" sx={{ mt: 1 }}>
                  {errors.faqs}
                </Typography>
              )}
            </Box>
          )}
        </Grid>

        <Grid item xs={12}>
          <Typography variant="subtitle1" gutterBottom>
            Captura de Leads: Quando um cliente demonstrar interesse, quais informações o assistente deve coletar antes de passar para você?
          </Typography>
          <FormGroup>
            <FormControlLabel
              control={
                <Checkbox
                  checked={formData.leadCapture.name}
                  onChange={handleCheckboxChange}
                  name="leadCapture.name"
                />
              }
              label="Nome"
            />
            <FormControlLabel
              control={
                <Checkbox
                  checked={formData.leadCapture.phone}
                  onChange={handleCheckboxChange}
                  name="leadCapture.phone"
                />
              }
              label="Telefone"
            />
            <FormControlLabel
              control={
                <Checkbox
                  checked={formData.leadCapture.email}
                  onChange={handleCheckboxChange}
                  name="leadCapture.email"
                />
              }
              label="E-mail"
            />
            <FormControlLabel
              control={
                <Checkbox
                  checked={formData.leadCapture.interest}
                  onChange={handleCheckboxChange}
                  name="leadCapture.interest"
                />
              }
              label="Qual serviço/produto ele tem interesse?"
            />
            <TextField
              fullWidth
              id="leadCapture.other"
              label="Outro"
              name="leadCapture.other"
              value={formData.leadCapture.other}
              onChange={handleChange}
              sx={{ mt: 2 }}
            />
          </FormGroup>
        </Grid>

        <Grid item xs={12}>
          <TextField
            fullWidth
            id="appointmentTool"
            label="Agendamentos: Você usa alguma ferramenta de agendamento online?"
            name="appointmentTool"
            value={formData.appointmentTool}
            onChange={handleChange}
            helperText="Se sim, cole o link aqui (Calendly, Google Agenda, etc.)"
          />
        </Grid>
      </Grid>
    </>
  );
};

export default Page4Objectives;